<template>
  <div>
    <main role="primary">
      <div class="row expanded collapse">
        <div class="small-12 large-6 column">
          <div class="mxr-look" :style="{height: `${sectionHeight}px`}">
            <div class="mxr-product-price" v-if="totalPrice !== '0.00'">
              <div class="st-price">
                <div class="price-info">
                </div>
                <div class="pricetag">
                  <div class="price">
                    {{ totalPrice | getAmount}}€
                  </div>
                  <div class="decimal">
                    {{ totalPrice | getCents}}
                  </div>
                </div>
              </div>
            </div>
            <div class="mxr-look__large" :style="{background: `url(${look.images.large}) center center / cover`}">
              <div class="mxr-look__large--hover" :style="{background: `url(${look.images.platter}) center center / cover`}"></div>
              <div class="mxr-look__title show-for-medium">
                <h2 v-colorize="look.hex_color">#{{lookId | padToTwo}}</h2>
              </div>
              <button class="mxr-look__scroll hide-for-medium"><i class="zmdi zmdi-chevron-down"></i></button>
            </div>
          </div>
        </div>
        <div class="small-12 large-6 column">
          <div class="mxr-look__scene--head">
            <img v-if="look.images.scenes" :src="look.images.scenes[0]" alt="">
          </div>
          <div class="mxr-look__content">
            <div class="row">
              <div class="column small-10 medium-6" v-if="look.designers_word">
                <blockquote class="mxr-quote">
                  <p>“{{look.designers_word}}”</p>
                  <cite><strong>{{ look.designers_name }}</strong>, {{ look.designers_job }}</cite>
                </blockquote>
              </div>
              <div class="column small-10 medium-6" v-else>
                <blockquote class="mxr-quote">
                  <p>Find your rythm, enjoy your run ! Chacun trouvera son rythme en fonction de ses capacités, chacun trouvera son style en fonction de ses envies et de ses émotions.</p>
                </blockquote>
              </div>
              <div class="column medium-5 show-for-large">
                <div class="mxr-product-count">
                  <div class="mxr-product-count__num" v-colorize="look.hex_color">{{ (products).length }}</div>
                  <div class="mxr-product-count__word">Prodotti</div>
                </div>
              </div>
            </div>
            <div class="row collapse align-right">
              <div class="small-12 large-9 column">
                <div class="show-for-small hide-for-medium">
                  <img v-if="look.images.scenes" :src="look.images.platter" alt="">
                </div>
                <div class="mxr-look__scene--body">
                  <img v-if="look.images.scenes" :src="look.images.scenes[1]" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="mxr-look__products">
            <nav class="carousel-nav">
              <button class="button top show-for-large" @click="scrollNavUp"><i class="zmdi zmdi-chevron-up"></i></button>
              <div class="carousel-nav__inner">
                <div class="carousel-cell" v-for="(product, index) in products" @click="selectIndex($event, index)">
                  <img :src="product.openGraph.image" alt="" width="62">
                </div>
              </div>
              <button class="button bottom show-for-large" @click="scrollNavDown"><i class="zmdi zmdi-chevron-down"></i></button>
            </nav>
            <div class="mxr-look__slider__wrap">
              <div class="mxr-product-price">
              <div class="st-price">
                <div class="price-info">
                </div>
                <div class="pricetag">
                  <div class="price">
                    {{ currentProdPrice | getAmount}}€
                  </div>
                  <div class="decimal">
                    {{ currentProdPrice | getCents}}
                  </div>
                </div>
              </div>
            </div>
              <flickity v-if="products.length" ref="looksProductSlider" class="mxr-look__slider" :options="flickityOptions">
                <div class="cell" :data-product="product.productInfo.productId" v-for="product in products">
                  <product-pic :product="product" :key="product.productInfo.productId"></product-pic>
                </div>
              </flickity>
            </div>
            <div class="mxr-look__decli" v-if="products.length">
              <product-declination :product="productFiltered[0]"></product-declination>
            </div>
            <product-add :product="productFiltered[0]"></product-add>
          </div>
        </div>
      </div>
    </main>
    <borders :prevLabel="prevLabel" :showChevronDown="true" :nextLabel="nextLabel" :show-corners="false" :show-text="false" :show-dots="false"></borders>
  </div>
</template>

<script>
  import borders from '@/components/Borders';
  import productAdd from '@/components/ProductAdd';
  import productPic from '@/components/ProductPic';
  import { TweenMax, Power4 } from 'gsap';
  import 'gsap/ScrollToPlugin';
  import productDeclination from '@/components/ProductDeclination';
  import Flickity from 'vue-flickity';
  import utils from '../utils';

  export default {
    name: 'looks',
    components: {
      borders,
      productPic,
      productAdd,
      productDeclination,
      Flickity,
    },
    head: {
      title() {
        return {
          inner: 'Kalenji by Decathlon',
          separator: '–',
          complement: `Look ${this.genderType} #${this.$options.filters.padToTwo(this.$route.params.id)}`,
        };
      },
      meta() {
        return [
          { name: 'description', content: this.look.designers_word || 'Find your rhythm, enjoy your run ! Chacun trouvera son rythme en fonction de ses capacités, chacun trouvera son style en fonction de ses envies et de ses émotions.' },
        ];
      },
    },
    data() {
      return {
        gender: this.$route.params.gender,
        lookId: this.$route.params.id,
        look: this.$root.looks[this.$route.params.gender][this.$route.params.id],
        looks: this.$root.looks[this.$route.params.gender],
        looksGenderSize: Object.keys(this.$root.looks[this.$route.params.gender]).length,
        products: [],
        sectionHeight: '',
        currentId: '',
        currentProdPrice: '',
        flickityOptions: {
          initialIndex: 0,
          setGallerySize: true,
          imagesLoaded: false,
          percentPosition: true,
          groupCells: false,
          bgLazyLoad: false,
          contain: false,
          prevNextButtons: false,
          pageDots: true,
          wrapAround: true,
          accessibility: true,
        },
      };
    },
    computed: {
      nextLabel() {
        let nextLabel = parseInt(this.lookId, 10) + 1;
        nextLabel = (this.looksGenderSize >= nextLabel) ? nextLabel : 1;
        return nextLabel;
      },
      prevLabel() {
        let prevLabel = parseInt(this.lookId, 10) - 1;
        prevLabel = (prevLabel > 0) ? prevLabel : 12;
        return prevLabel;
      },
      cartFiltered() {
        return this.$store.getters.cart.filter(p => p.gender === this.$route.params.gender)
        .filter(p => parseInt(p.look, 10) === parseInt(this.$route.params.id, 10));
      },
      productFiltered() {
        return this.products.filter(p => p.productInfo.productId === this.currentId);
      },
      genderType() {
        let gender = '';
        if (this.gender === 'men') {
          gender = 'Uomo';
        } else if (this.gender === 'women') {
          gender = 'Donna';
        }
        return gender;
      },
      totalPrice() {
        let total = 0;
        const prices = this.products.map(p => p.productVariant[0].price);
        total = prices.reduce((pv, cv) => pv + cv, 0);
        return total.toFixed(2);
      },
    },
    methods: {
      changeItem(event) {
        this.selector = event.target.id;
        this.product.id = event.target.value;
      },
      scrollNavUp() {
        const currPos = document.querySelectorAll('.carousel-nav__inner')[0].scrollTop;
        TweenMax.to('.carousel-nav__inner', 1, { scrollTo: currPos - 112, ease: Power4.easeOut });
      },
      scrollNavDown() {
        const currPos = document.querySelectorAll('.carousel-nav__inner')[0].scrollTop;
        TweenMax.to('.carousel-nav__inner', 1, { scrollTo: currPos + 112, ease: Power4.easeOut });
      },
      selectIndex(e, index) {
        this.$refs.looksProductSlider.select(index);
        /* function offset(elt) {
          const rect = elt.getBoundingClientRect();
          const bodyElt = document.body;
          return {
            top: rect.top + bodyElt.scrollTop,
            left: rect.left + bodyElt.scrollLeft,
          };
        }
        const carouselNav = document.querySelectorAll('.carousel-nav')[0];
        const carouselNavInner = carouselNav.querySelectorAll('.carousel-nav__inner')[0];
        const cell = carouselNavInner.querySelectorAll('.carousel-cell')[0];
        const navHeight = carouselNav.clientHeight;
        const navInnerHeight = carouselNavInner.clientHeight;
        const cellHeight = cell.clientHeight;

        const cellPos = offset(e.target).top - offset(carouselNavInner).top;
        const scrollY = ((cellPos + cellHeight) + (navHeight / 2)) - (navInnerHeight / 2);
        console.log(scrollY);
        TweenMax.to('.carousel-nav', 1, { scrollTo: scrollY, ease: Power4.easeOut }); */
      },
    },
    mounted() {
      this.$store.commit('nextLabel', this.nextLabel);
      this.$store.commit('prevLabel', this.prevLabel);
      this.$store.commit('currentGender', this.$route.params.gender);
      this.$store.commit('showCart');
      this.$store.commit('showBorders');
      this.sectionHeight = utils.getBorderedViewport();
      this.$on('currentProdPrice', (value) => {
        this.currentProdPrice = value;
      });
      this.$root.$on('goto', (value) => {
        if (value === 'next') {
          this.$router.push({ path: `/looks/${this.$store.state.currentgender}/${this.$store.state.nextLook}` });
        } else if (value === 'prev') {
          this.$router.push({ path: `/looks/${this.$store.state.currentgender}/${this.$store.state.prevLook}` });
        }
      });
      utils.fetchAllProducts(this.look.references, (array) => {
        this.products = array;
      });
    },
    updated() {
      if (this.products.length) {
        this.currentId = this.$refs.looksProductSlider.data().selectedElement.dataset.product;
        this.$refs.looksProductSlider.on('select', () => {
          this.currentId = this.$refs.looksProductSlider.data().selectedElement.dataset.product;
        });
      }
    },
  };
</script>

<style lang="scss">
  .mxr-product-price {
    position: absolute;
    top: 0;
    right: 0;
    font-family: $body-font-family-alt;
    padding: rem-calc(10 14);
    z-index: 2;
    margin: rem-calc(10);
    @include breakpoint(medium) {
      margin: rem-calc(40);
    }
  }
  .carousel-nav {
    @include breakpoint(large) {
      box-shadow: rem-calc(0 4 20 0) rgba(black, .06), rem-calc(0 1 10 -5) rgba(0, 0, 0, 0.18);
      position: absolute;
      left: 0;
      transform: translateX(-50%);

      &__inner {
        max-height: rem-calc(500);
        overflow: scroll;
      }

      .button {
        position: absolute;
        z-index: 1;
        margin: 0;
        left: 50%;
        transform: translateX(-50%);
        font-size: rem-calc(24);
        padding: rem-calc(2 26);
        width: 100%;
        background: none;
        color: $body-font-color;

        &.top {
          bottom: 100%;
        }

        &.bottom {
          top: 100%;
        }
      }
    }

    .carousel-cell {
      width: 33.333333%;
      display: inline-block;
      text-align: center;
      background: $white;
      padding: rem-calc(25);
      cursor: pointer;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        background: none;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
      @include breakpoint(medium) {
        width: 25%;
      }
      @include breakpoint(large) {
        display: block;
        width: 100%;
      }

      & + .carousel-cell {
        @include breakpoint(large) {
          border-top: rem-calc(1) solid lighten($blue-gray, 15%);
        }
      }
    }
  }
  .mxr-product-count {
    position: relative;
    z-index: 0;
    margin-top: rem-calc(-90);
    text-align: center;
    background: $white;
    box-shadow: rem-calc(0 4 20 0) rgba(black, .06), rem-calc(0 1 10 -5) rgba(0, 0, 0, 0.18);
    padding: rem-calc(10 12 40);
    margin-bottom: rem-calc(20);
    font-family: $body-font-family-alt;
    &__num {
      font-size: rem-calc(180);
      font-weight: $global-weight-bold;
      font-style: italic;
      line-height: 1.3;
    }
    &__word {
      display: inline-block;
      text-transform: uppercase;
      letter-spacing: .311em;
      margin-top: rem-calc(-20);
      padding-top: rem-calc(20);
      position: relative;
      color: darken($blue-gray, 10%);
      &:before {
        content: '';
        position: absolute;
        height: rem-calc(2);
        background: $blue-gray;
        opacity: .2;
        width: 50%;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
      }
    }
  }
  .mxr-quote {
  }
  .mxr-look {
    position: relative;
    overflow: hidden;
    @include breakpoint(large) {
      position: fixed;
      width: calc(50% - 40px);
      top: $borders-width-md;
    }

    &__scroll {
      position: absolute;
      bottom: 0;
      padding: rem-calc(20);
      font-size: rem-calc(24);
      left: 50%;
      transform: translateX(-50%);
      animation: scroll 1s infinite;
      @at-root {
        @keyframes scroll {
          0% {
            transform: translateY(rem-calc(-20)) translateX(-50%);
          }
          50% {
            transform: translateY(rem-calc(0)) translateX(-50%);
          }
          100% {
            transform: translateY(rem-calc(-20)) translateX(-50%);
          }
        }
      }
    }
    &__decli {
      display: flex;
      justify-content: center;
    }
    &__back {
      display: flex;
      opacity: .3;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      padding: rem-calc(16);
      i {
        font-size: rem-calc(18);
        margin-right: rem-calc(16);
      }
      a {
        text-transform: uppercase;
        letter-spacing: .711em;
        font-size: rem-calc(13);
        font-weight: $global-weight-bold;
        line-height: 1;
      }
    }
    &__products {
      position: relative;
      @include breakpoint(large) {
        padding-left: rem-calc(50)
      }
    }
    &__large {
      z-index: 0;
      animation: moveRight 1.3s $anim-curve forwards;
      background-repeat: no-repeat;
      min-height: 100%;

      &:after {
        content: '';
        background: $white;
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        animation: slideRight 1000ms $anim-curve forwards;
      }
      &:before {
        content: '';
        position: absolute;
        background: $white;
        height: 100%;
        width: 100%;
        left: 0;
        top: 100%;
        transform: skewY(0deg);
        transform-origin: 0 0;
        z-index: -1;
        transition: all cubic-bezier(0.745, 0.200, 0.020, 0.970) .4s;
      }

      &:hover {
        @include breakpoint(large) {
          &:before {
            transform-origin: 0 0;
            transform: skewY(-6deg);
          }
        }
      }

      &--hover {
        opacity: 0;
        position: relative;
        z-index: -2;
        transition: all ease .8s;
        transform: translateY(rem-calc(-30));
        width: 100%;
        @include breakpoint(large) {
          min-height: rem-calc(622);
        }

        &:hover {
          opacity: 1;
          transform: translateY(0);

          & + .mxr-look__title {
            transform: scale(.9) translateY(rem-calc(-46));
          }
        }
      }
    }
    &__content {
      //display: flex;
      //flex-direction: column;
      @include breakpoint(large) {
        padding-left: rem-calc(30);
        padding-top: rem-calc(45);
      }
      footer {
        border-top: rem-calc(1) solid #F4F4F4;
        margin-top: auto;
        padding: rem-calc(30) 0;
      }
    }
    &__title {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      position: absolute;
      top: 100%;
      margin-top: rem-calc(-62);
      right: rem-calc(56);
      transition: transform $anim-curve .5s;
      h1 {
        color: #B5B7B8;
        text-transform: uppercase;
        font-size: rem-calc(14);
        letter-spacing: .711em;
        margin-right: rem-calc(-.711em);
        font-weight: bold;
        animation: moveRightText 1.6s $anim-curve forwards;
      }
      h2 {
        font-size: rem-calc(110);
        font-family: $body-font-family-alt;
        font-weight: bold;
        font-style: italic;
        letter-spacing: -.05em;
        line-height: .86;
        animation: moveRightText 1.2s $anim-curve forwards;
      }
    }
    &__slider {
      margin-bottom: rem-calc(60);
      .cell {
        min-height: rem-calc(400);
        width: 100%;
        display: flex;
      }
      &__wrap {
        position: relative;
      }
    }
    &__scene {
      &--head {
        position: relative;
        overflow: hidden;
        @include breakpoint(large) {
          margin-left: rem-calc(40);
        }
        @include breakpoint(medium) {
          &:before {
            content: '';
            position: absolute;
            background: $white;
            top: 0;
            left: 100%;
            width: 20%;
            height: 100%;
            transform: skewX(10deg);
            transform-origin: 100% 100%;
          }
/*           &:after {
            content: '';
            position: absolute;
            background: $white;
            top: 0;
            right: 100%;
            width: 20%;
            height: 100%;
            transform: skewX(10deg);
            transform-origin: 0 50%;
          } */
        }
      }
      &--body {
        position: relative;
        overflow: hidden;
        @include breakpoint(medium) { 
          &:before {
            content: '';
            background: $white;
            position: absolute;
            top: 0;
            right: 100%;
            width: 100%;
            height: 100%;
            transform: skewX(10deg);
            transform-origin: 0 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Look.vue?80911bac